/* eslint-disable */
export const all = state => state.all;
export const received = state => state.received;
export const sended = state => state.sended;
export const currentPage = state => state.currentPage;
export const totalResources = state => state.totalResources;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const loadingData = state => state.loadingData;
export const notificationBar = state => state.notificationBar;
export const showFilters = state => state.showFilters;
export const filterParams = state => state.filterParams;
export const ordination = state => state.ordination;

export const bill = state => state.bill;
export const billErrors = state => state.billErrors;
export const billPayment = state => state.billPayment;
export const showBillPayment = state => state.showBillPayment;
export const showBillPayments = state => state.showBillPayments;
export const billPaymentError = state => state.billPaymentError;

export const billsList = state => state.billsResources.resources;
export const billsResourcesCount = state => state.billsResources.resourcesCount;
export const billsCurrentPage = state => state.billsResources.currentPage;
export const billsLoadingData = state => state.billsResources.loadingData;
export const billsStatus = state => state.billsResources.status;
export const billsLimitOptions = state => state.billsResources.limitOptions;
export const billsLimit = state => state.billsResources.limit;

export const billsPaymentList = state => state.billsPaymentResources.resources;
export const billsPaymentResourcesCount = state => state.billsPaymentResources.resourcesCount;
export const billsPaymentCurrentPage = state => state.billsPaymentResources.currentPage;
export const billsPaymentLoadingData = state => state.billsPaymentResources.loadingData;
export const billsPaymentStatus = state => state.billsPaymentResources.status;
export const billsPaymentLimitOptions = state => state.billsPaymentResources.limitOptions;
export const billsPaymentLimit = state => state.billsPaymentResources.limit;

// filter and export params
export const filtersId = state => state.filtersId;
export const filtersTypeName = state => state.filtersTypeName;
export const filtersPositive = state => state.filtersPositive;
export const filtersTypeId = state => state.filtersTypeId;
export const filtersKind = state => state.kind;
export const filtersAmount = state => state.filtersAmount;
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersTransactionType = state => state.filtersTransactionType;
export const filtersStatus = state => state.filtersStatus;
export const filtersPayerName = state => state.filtersPayerName;

export const billsPaymentFilter = state => {
  const billsPaymentFilters = {
    page: state.billsPaymentResources.currentPage || 1,
    limit: state.billsPaymentResources.limit,
    ordination: state.ordination,
    with_type_name: state.filtersTypeName
  };
  return billsPaymentFilters;
};

export const billsFilter = state => {
  const billsFilters = {
    page: state.billsResources.currentPage || 1,
    limit: state.billsResources.limit,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      with_status: state.filtersStatus,
      with_payer_name: state.filtersPayerName,
      with_amount: state.filtersAmount,
      sorted_by: state.filtersOrdination
    }
  };
  return billsFilters;
};

export const billsSubtotal = state => {
  const resources = state.billsResources.resources || [];
  if (resources.length === 0) return 0;
  return resources.reduce((sum, bill) => sum + (parseFloat(bill.amount) || 0), 0);
};

export const billsPaymentSubtotal = state => {
  const resources = state.billsPaymentResources.resources || [];
  if (resources.length === 0) return 0;
  return resources.reduce((sum, bill) => sum + (parseFloat(bill.bill_amount) || 0), 0);
};

/* eslint-disable */
export const billsfilterExport = state => {
  const filters = {
    page: state.currentPage || 1,
    limit: state.limit,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      id: state.filtersId,
      with_type_name: state.filtersTypeName,
      positive: state.filtersPositive,
      type_id: state.filtersTypeId,
      kind: state.filtersKind,
      amount: state.filtersAmount,
      created_at: state.filtersInitialDate,
      sorted_by: state.filtersOrdination
    }
  };
  return filters;
};

export const pagination = state => {
  const page = {
    page: state.currentPage,
    rowsPerPage: state.limitOptions,
    totalItems: state.totalResources
  };
  return page;
};

// DARF Payment Getters
export const darfPayment = state => state.darfPayment;
export const showDarfPayment = state => state.showDarfPayment;
export const darfPaymentError = state => state.darfPaymentError;
export const darfPaymentLoadingData = state => state.darfPaymentLoadingData;

export const darfsPaymentList = state => state.darfsPaymentResources.resources;
export const darfsPaymentResourcesCount = state => state.darfsPaymentResources.resourcesCount;
export const darfsPaymentCurrentPage = state => state.darfsPaymentResources.currentPage;
export const darfsPaymentLoadingData = state => state.darfsPaymentResources.loadingData;
export const darfsPaymentStatus = state => state.darfsPaymentResources.status;
export const darfsPaymentLimitOptions = state => state.darfsPaymentResources.limitOptions;
export const darfsPaymentLimit = state => state.darfsPaymentResources.limit;

export const darfsPaymentFilter = state => {
  const darfsPaymentFilters = {
    page: state.darfsPaymentResources.currentPage || 1,
    limit: state.darfsPaymentResources.limit,
    ordination: state.ordination,
    with_type_name: state.filtersTypeName
  };
  return darfsPaymentFilters;
};

// PIX Payment Getters
export const pixPayment = state => state.pixPayment;
export const showPixPayment = state => state.showPixPayment;
export const pixPaymentError = state => state.pixPaymentError;
export const pixPaymentLoadingData = state => state.pixPaymentLoadingData;

export const pixPaymentList = state => state.pixPaymentResources.resources;
export const pixPaymentResourcesCount = state => state.pixPaymentResources.resourcesCount;
export const pixPaymentCurrentPage = state => state.pixPaymentResources.currentPage;
export const pixPaymentStatus = state => state.pixPaymentResources.status;
export const pixPaymentLimit = state => state.pixPaymentResources.limit;

export const pixPaymentFilter = state => {
  const pixPaymentFilters = {
    page: state.pixPaymentResources.currentPage || 1,
    limit: state.pixPaymentResources.limit
  };
  return pixPaymentFilters;
};
